import { flatten, map } from 'lodash'

const getTreeIdsFromLevelToLevel = (nodes, currentLevel, maxLevel) => {
  if (currentLevel === maxLevel) {
    return map(nodes, 'id')
  }

  return flatten(
    map(nodes, node => [
      node.id,
      ...getTreeIdsFromLevelToLevel(node.children, currentLevel + 1, maxLevel),
    ]),
  )
}

export default getTreeIdsFromLevelToLevel
